import React from 'react'
import { useParams } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import CampaignInfluencerSidebarNavBase from '../../../../../Shared/CampaignInfluencerSidebar/CampaignInfluencerSidebarNavBase'

export default observer(function CampaignInfluencerSidebarNav({ camp_auth_id }) {
  const {id, campaign_authentication_id } = useParams()
  const basePath = `/project_manager/campaigns/${id}/influencers/campaign_authentications/${campaign_authentication_id}`
  const links = [
    { key: 'tags', text: 'Tags', href: `${basePath}/tags` },
    { key: 'profile', text: 'Profile', href: `${basePath}/profile` },
    { key: 'pm_thread', text: 'PM thread', href: `${basePath}/pm_thread` },
    { key: 'client_thread', text: 'Client thread', href: `${basePath}/client_thread` },
  ]

  return (
    <CampaignInfluencerSidebarNavBase links={links} />
  )
})
